import { render, staticRenderFns } from "./GlobalTypographySaveDialog.vue?vue&type=template&id=762e6a68&"
import script from "./GlobalTypographySaveDialog.vue?vue&type=script&lang=ts&"
export * from "./GlobalTypographySaveDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports